AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.CompaniesController extends AccessController
    constructor: (@scope, @transitions, @modal, @companiesService, @http) ->
        super('companies', @http)

        @scope.fullpage = true
        @scope.title = 'Companies'
        @scope.companies = []

        # Functions
        @scope.openNewCompanyDialog = @openNewCompanyDialog
        @scope.openEditCompanyPagesDialog = @openEditCompanyPagesDialog
        @scope.openEditCompanyLineupsDialog = @openEditCompanyLineupsDialog

        @loadCompanies()

    loadCompanies: () =>
        @loadScopeData @companiesService.getCompaniesData(), 'companies'


    openNewCompanyDialog: () =>
        dlg = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/companies/new-company'
            controller: 'Tools.Controllers.NewCompanyController'

        dlg.result.then () =>
            @loadCompanies()


    openEditCompanyPagesDialog: (company) =>
        @modal.open
            windowClass: 'large_dialog'
            templateUrl: 'backend/admin/new-tools/companies/company-pages'
            controller: 'Tools.Controllers.EditCompanyPagesController'
            resolve:
                company: () =>
                    company
                pages: @companiesService.getPagesForCompany company.id
                reports: @companiesService.getReportsForCompany company.id


    openEditCompanyLineupsDialog: (company) =>
        @modal.open
            windowClass: 'medium_dialog'
            templateUrl: 'backend/admin/new-tools/companies/company-lineups'
            controller: 'Tools.Controllers.EditCompanyLineupsController'
            resolve:
                company: () =>
                    company
                lineups: @companiesService.getLineupsForCompany company.id
                crops: @companiesService.getAllCrops()
                seedCompanies: @companiesService.getAllSeedCompanies()
